export const CCF_CALCULATION_LOCAL_STORAGE_PREFIX = "ccfCalculation";
